@if (canSee()) {
  <section class="advertisers" [class.advertisers--home]="isHome()">
    @if (!isHome()) {
      <h3 class="title">Nossos Anunciantes</h3>
    }

    <div class="band">
      @if (!isHome()) {
        <div class="stat">
          <div class="head">
            <span class="pulse" aria-hidden="true"></span>
            <span class="label">Veículos disponíveis</span>
          </div>
          <span #count class="value"></span>

          @if (selectedDealer(); as dealer) {
            <div class="selected">
              <span class="caption">Anunciante selecionado</span>
              <div class="chip">
                <img [src]="dealer.logo" [alt]="dealer.name" draggable="false">
                <span class="chip-name" [title]="dealer.name">{{ dealer.name }}</span>
                <button type="button" class="clear" aria-label="Remover anunciante selecionado"
                  (click)="clearSelection()">
                  <i class="fa-solid fa-xmark" aria-hidden="true"></i>
                </button>
              </div>
            </div>
          } @else {
            <div class="dealers">
              <i class="fa-solid fa-store" aria-hidden="true"></i>
              <span>{{ oemDealers().length }} anunciantes</span>
            </div>
          }
        </div>
      }

      <div #viewport class="viewport" [class.viewport--dragging]="dragging()">
        <div #track class="track">
          @for (sequence of sequences(); track $index; let sequenceIndex = $index) {
            <div class="sequence" [attr.aria-hidden]="sequenceIndex > 0 ? 'true' : null">
              @for (oemDealer of oemDealers(); track oemDealer.id) {
                <button
                  type="button"
                  class="dealer"
                  [class.dealer--selected]="isSelected(oemDealer)"
                  [attr.tabindex]="sequenceIndex > 0 ? -1 : 0"
                  [attr.aria-pressed]="isSelected(oemDealer)"
                  [attr.aria-label]="actionLabel(oemDealer)"
                  (click)="onDealerClick(oemDealer)">
                  <span class="logo">
                    <img [src]="oemDealer.logo" [alt]="oemDealer.name" draggable="false" loading="lazy">
                  </span>
                  <span class="name">{{ oemDealer.name }}</span>
                </button>
              }
            </div>
          }
        </div>
      </div>
    </div>
  </section>
}
